import { gql } from "@apollo/client"

export const USER_SEARCH = gql`
  query UserSearch($UserSearchInput: UserSearchInput!) {
    UserSearch(input: $UserSearchInput) {
      status {
        success
        name
        detail
      }
      Persons {
        id
        code
        email
        name
        fullName
        documentNumber
        documentNumberType
      }
    }
  }
`
